export const categories = [
  {
    slug: 'yingshi',
    name: '影视',
    icon: 'ri-movie-2-line',
    description: '海量电影、电视剧、综艺节目磁力链接，高清无水印资源一键搜索',
    color: 'accent',
    count: 12580,
  },
  {
    slug: 'yinyue',
    name: '音乐',
    icon: 'ri-music-2-line',
    description: '无损音乐、专辑合集、演唱会资源磁力链接免费搜索下载',
    color: 'primary',
    count: 8932,
  },
  {
    slug: 'ruanjian',
    name: '软件',
    icon: 'ri-terminal-box-line',
    description: '各类实用软件、开发工具、操作系统镜像磁力链接资源',
    color: 'secondary',
    count: 5640,
  },
  {
    slug: 'dianzishu',
    name: '电子书',
    icon: 'ri-book-read-line',
    description: '小说、技术书籍、学术文献电子书磁力链接资源库',
    color: 'accent',
    count: 7215,
  },
  {
    slug: 'youxi',
    name: '游戏',
    icon: 'ri-gamepad-line',
    description: 'PC游戏、主机游戏、手游资源磁力链接免费搜索',
    color: 'primary',
    count: 9876,
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-emotion-line',
    description: '日本动漫、国产动画、美漫资源磁力链接大全',
    color: 'secondary',
    count: 6543,
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-camera-lens-line',
    description: 'BBC、国家地理、Discovery等经典纪录片磁力链接资源',
    color: 'accent',
    count: 3210,
  },
  {
    slug: 'xuexi',
    name: '学习资料',
    icon: 'ri-graduation-cap-line',
    description: '公开课、教程、考试资料等学习资源磁力链接搜索',
    color: 'primary',
    count: 4567,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});